import { defineStore } from 'pinia'

import { useGenericRefineIdeas } from '~/entities/content/idea/stores/refine-ideas'

import SwymServices from '~/features-shared/content/api/contents'
import ExaleadServices from '~/features-shared/content/api/exalead-contents'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'
import { ServiceFetchControllerDefault } from '~/features-shared/content-feed/controllers/services-fetch-controller-default'

// Once we have a go from backend, we can replace this store by the useRefineIdeasStore

export const useRefineDerivedIdeasStore = defineStore('refineDerivedIdeas', () =>
  useGenericRefineIdeas(
    new ServiceFetchControllerDefault(SwymServices[IContentModel.DerivedIdea], ExaleadServices[IContentModel.Idea]),
  ))
